import type { Map as MapLibreMap } from "maplibre-gl";

const DEM_SOURCE = "tactical-dem";

export function tacticalDemTilesUrl(): string {
  return String(import.meta.env.VITE_TACTICAL_DEM_TILES_URL || "").trim();
}

export function tacticalDemEncoding(): "terrarium" | "mapbox" {
  const raw = String(import.meta.env.VITE_TACTICAL_DEM_ENCODING || "terrarium")
    .trim()
    .toLowerCase();
  return raw === "mapbox" ? "mapbox" : "terrarium";
}

/** Подключает raster-dem + setTerrain при наличии URL. Возвращает true, если terrain активен. */
export function ensureTacticalTerrain(map: MapLibreMap): boolean {
  const url = tacticalDemTilesUrl();
  if (!url) {
    try {
      map.setTerrain(null);
    } catch {
      /* ignore */
    }
    return false;
  }
  try {
    if (!map.getSource(DEM_SOURCE)) {
      map.addSource(DEM_SOURCE, {
        type: "raster-dem",
        tiles: [url],
        tileSize: 256,
        encoding: tacticalDemEncoding(),
        maxzoom: 15,
      });
    }
    map.setTerrain({ source: DEM_SOURCE, exaggeration: 1.15 });
    return true;
  } catch {
    return false;
  }
}

export function clearTacticalTerrain(map: MapLibreMap): void {
  try {
    map.setTerrain(null);
  } catch {
    /* ignore */
  }
  try {
    if (map.getSource(DEM_SOURCE)) map.removeSource(DEM_SOURCE);
  } catch {
    /* ignore */
  }
}

export function queryGroundM(map: MapLibreMap, lng: number, lat: number): number | null {
  try {
    const v = map.queryTerrainElevation({ lng, lat });
    return typeof v === "number" && Number.isFinite(v) ? v : null;
  } catch {
    return null;
  }
}
